module.exports = __webpack_public_path__ + "img/chaleco.a2e87557.png";